
export const STATUS = {
  inPreparation: 'inpreparation',
  inProcess: 'inprocess',
  Finished: 'finished'
}
export class PhoneUtils { }
